import React from 'react';
import { SlaState } from '../../shared/ui-models/lead.ui-model';

const STYLE: Record<SlaState, { label: string; className: string; title: string }> = {
  [SlaState.MET]: {
    label: 'met',
    className: 'bg-green-50 text-green-700',
    title: 'Answered inside the target'
  },
  [SlaState.BREACHED]: {
    label: 'breached',
    className: 'bg-red-50 text-red-700',
    title: 'Answered late, or still unanswered past the target'
  },
  [SlaState.AT_RISK]: {
    label: 'at risk',
    className: 'bg-amber-50 text-amber-800',
    title: 'Unanswered and close to the target'
  },
  [SlaState.AWAITING]: {
    label: 'awaiting',
    className: 'bg-blue-50 text-blue-700',
    title: 'Unanswered and comfortably inside the target'
  },
  [SlaState.UNKNOWN]: {
    label: '—',
    // Deliberately grey and unalarming: no target was recorded, which is not
    // the same as a missed one and should not read like a breach.
    className: 'bg-gray-100 text-gray-500',
    title: 'No SLA target recorded for this lead'
  }
};

export const SlaBadge: React.FC<{ state: SlaState }> = ({ state }) => {
  const style = STYLE[state];
  return (
    <span className={`rounded-full px-2 py-0.5 text-xs ${style.className}`} title={style.title}>
      {style.label}
    </span>
  );
};
